export default "__VITE_ASSET__BHwthrZi__"